import { formatCurrency, convertCurrency } from '../utils/currency';
/**
 * Magics for money formatting in the browser.
 *
 * - $formatCurrency(amount, format?) - Formats an amount in cents as a money string via
 *   Intl.NumberFormat. Defaults for currency and locale come from window.theme.currency,
 *   then window.Shopify.currency.
 * - $convertCurrency(amount, rate?) - Multiplies an amount by a currency rate
 *   (default window.Shopify.currency.rate, the rate for the presented currency).
 *
 * Format options and edge cases live in utils/currency.ts, next to the formatters.
 *
 * @example
 * <span x-text="$formatCurrency(1999)"></span>
 * <span x-text="$formatCurrency(1999, {rounded: true, form: 'explicit'})"></span>
 */
export default function (Alpine) {
    Alpine.magic('formatCurrency', () => {
        return formatCurrency;
    });
    Alpine.magic('convertCurrency', () => {
        return convertCurrency;
    });
}
